import type {DecorationSingleComponentPluginFunction} from '../../types'
import type {ComponentExportStructure} from '@wix/document-services-types'
import {SUPPORTED_DATA_TYPES} from './constants'
import {linkReferenceUtil} from '../../utils/linkReference'

export const unpack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    const type = component.data?.type
    if (!type || !SUPPORTED_DATA_TYPES.has(type)) {
        return
    }

    const link = linkReferenceUtil.unpack(component)
    if (link) {
        component.data.link = link
    }
}
